module.exports = __webpack_public_path__ + "n.no2.1a883301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/n.no2.jpg
// module id = 2+PI
// module chunks = 0